var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgESignalRoomControlSignalCommunicativeHeating = function SvgESignalRoomControlSignalCommunicativeHeating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 178,
    width: 2,
    height: 219,
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 70,
    width: 2,
    height: 92,
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 178,
    width: 2,
    height: 80.02,
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462 70 462 162 464 162 464 68 342 68 342 70 400 70 402 70 462 70",
    fill: "#1c9d5b"
  })))));
};
export default SvgESignalRoomControlSignalCommunicativeHeating;